import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SelectivePreloadingStrategy } from "./selective-preloading.strategy";
import { VideoResolver } from "./componentes/detalle-noticia/detalle-noticia.resolver";
import { DeviceBasedResolver } from "./componentes/device-based/device-based.resolver";
import { DeviceBasedComponent } from "./componentes/device-based/device-based/device-based.component";
import { PageNotFoundComponent } from "./componentes/page-not-found/page-not-found.component";
import { DetalleNoticiasService } from "./servicios/detalle-noticias/detalle-noticias.service";
import { ComentariosService } from "./servicios/comentarios/comentarios.service";

export const routes: Routes = [
  { path: "", component: DeviceBasedComponent, resolve: { isMobile: DeviceBasedResolver } },
  {
    path: "tag/:id",
    loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
    data: { url: "tag" },
  },
  {
    path: "subseccion/:id/:title",
    loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
    data: { url: "subseccion" },
  },
  {
    path: "noticias/:id",
    providers: [DetalleNoticiasService, ComentariosService],
    loadComponent: () => import("./componentes/detalle-noticia/detalle-noticia.component").then((comp) => comp.DetalleNoticiaComponent),
    resolve: { videoData: VideoResolver },
  },
  {
    path: "noticias/:id/:id2",
    providers: [DetalleNoticiasService, ComentariosService],
    loadComponent: () => import("./componentes/detalle-noticia/detalle-noticia.component").then((comp) => comp.DetalleNoticiaComponent),
    resolve: { videoData: VideoResolver },
  },
  {
    path: "noticias/:id/:id2/:id3",
    providers: [DetalleNoticiasService, ComentariosService],
    loadComponent: () => import("./componentes/detalle-noticia/detalle-noticia.component").then((comp) => comp.DetalleNoticiaComponent),
    data: { url: "subseccion" },
    resolve: { videoData: VideoResolver },
  },
  {
    path: "seccion/:id/:title",
    loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
    data: { url: "seccion" },
  },
  {
    path: "noticias-24-horas",
    loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
    data: { url: "tag", forceTitle: "Noticias 24 horas" },
  },
  {
    path: "canal/:id/:title",
    loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
    data: { url: "seccion" },
  },
  {
    path: "linea-editorial/:id/:id2/:id3",
    loadComponent: () => import("./componentes/carta-director/carta-director.component").then((comp) => comp.CartaDirectorComponent),
  },
  //     LOGIN
  {
    path: "login",
    loadComponent: () => import("./componentes/modal-login/modal-login.component").then((comp) => comp.ModalLoginComponent),
  },
  {
    path: "iniciar-sesion",
    loadComponent: () => import("./componentes/modal-login/modal-login.component").then((comp) => comp.ModalLoginComponent),
  },
  {
    path: "registro",
    loadComponent: () => import("./componentes/modal-registro/modal-registro.component").then((comp) => comp.ModalRegistroComponent),
  },

  //    /autor
  {
    path: "autor",
    children: [
      {
        path: ":id",
        loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
        data: { url: "autor" },
      },
      {
        path: ":id/:title",
        loadComponent: () => import("./componentes/vista-noticias/vista-noticias.component").then((comp) => comp.VistaNoticiasComponent),
        data: { url: "autor" },
      },
    ],
  },

  //   /buscar
  {
    path: "buscar",
    children: [
      {
        path: ":id",
        loadComponent: () => import("./componentes/buscador/buscador.component").then((comp) => comp.BuscadorComponent),
        data: [{ textoBusqueda: ":id" }],
      },
      {
        path: ":id/:id2",
        loadComponent: () => import("./componentes/buscador/buscador.component").then((comp) => comp.BuscadorComponent),
        data: [{ textoBusqueda: ":id" }],
      },
    ],
  },
  /* {
    path: 'politica-privacidad', loadComponent: () => import('./componentes/politica-privacidad/politica-privacidad.component').then(comp => comp.PoliticaPrivacidadComponent)
  }, */
  {
    path: "politica-cookies",
    loadComponent: () => import("./componentes/politica-cookies/politica-cookies.component").then((comp) => comp.PoliticaCookiesComponent),
  },
  {
    path: "blogs",
    children: [
      {
        path: "",
        loadComponent: () => import("./componentes/vista-blogs/vista-blogs.component").then((comp) => comp.VistaBlogsComponent),
      },
      {
        path: ":slug",
        loadComponent: () => import("./componentes/vista-post/vista-post.component").then((comp) => comp.VistaPostComponent),
      },
      {
        path: ":slug/posts/:slug2",
        loadComponent: () => import("./componentes/detalle-post/detalle-post.component").then((comp) => comp.DetallePostComponent),
      },
      {
        path: ":slug/posts/:id/:slug2",
        loadComponent: () => import("./componentes/detalle-post/detalle-post.component").then((comp) => comp.DetallePostComponent),
      },
    ],
  },
  {
    path: "albums",
    children: [
      {
        path: "",
        loadComponent: () => import("./componentes/detalle-album/detalle-album.component").then((comp) => comp.DetalleAlbumComponent),
      },
      {
        path: ":id",
        loadComponent: () => import("./componentes/detalle-album/detalle-album.component").then((comp) => comp.DetalleAlbumComponent),
      },
    ],
  },
  {
    path: "videos",
    children: [
      {
        path: ":id",
        loadComponent: () => import("./componentes/detalle-album/detalle-album.component").then((comp) => comp.DetalleAlbumComponent),
      },
    ],
  },
  {
    path: "aviso-legal",
    loadComponent: () => import("./componentes/pages/pages.component").then((comp) => comp.PagesComponent),
    data: { slug: "aviso-legal" },
  },
  {
    path: "politica-privacidad",
    loadComponent: () => import("./componentes/pages/pages.component").then((comp) => comp.PagesComponent),
    data: { slug: "politica-privacidad" },
  },
  {
    path: "pages/:slug",
    loadComponent: () => import("./componentes/pages/pages.component").then((comp) => comp.PagesComponent),
  },
  {
    path: "publications/:slug",
    loadComponent: () => import("./componentes/pages/pages.component").then((comp) => comp.PagesComponent),
  },
  {
    path: "publicaciones/:slug",
    loadComponent: () => import("./componentes/pages/pages.component").then((comp) => comp.PagesComponent),
  },
  {
    path: "hemeroteca",
    children: [
      {
        path: "",
        loadComponent: () => import("./componentes/hemeroteca/hemeroteca.component").then((comp) => comp.HemerotecaComponent),
      },
      {
        path: ":id",
        loadComponent: () => import("./componentes/hemeroteca/hemeroteca.component").then((comp) => comp.HemerotecaComponent),
      },
    ],
  },
  {
    path: "reels",
    loadComponent: () => import("./componentes/home-reels/home-reels.component").then((comp) => comp.HomeReelsComponent),
  },
  {
    path: "reels/:id/:id2",
    loadComponent: () => import("./componentes/home-reels/home-reels.component").then((comp) => comp.HomeReelsComponent),
  },
  {
    path: "revistas/list_all",
    loadComponent: () => import("./componentes/revista/revista.component").then((m) => m.RevistaComponent),
  },
  {
    path: "revista",
    children: [
      {
        path: "",
        loadComponent: () => import("./componentes/revista/revista.component").then((m) => m.RevistaComponent),
      },
      {
        path: ":id",
        loadComponent: () => import("./componentes/detalle-revista/detalle-revista.component").then((m) => m.DetalleRevistaComponent),
        data: { preload: false },
      },
    ],
  },
  { path: "404", component: PageNotFoundComponent },
  { path: "**", redirectTo: "/404" },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      onSameUrlNavigation: "reload",
      preloadingStrategy: SelectivePreloadingStrategy,
      enableViewTransitions: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
